import type { DemoUser, Role, RoleId } from '../types/notice';

export const roles: Role[] = [
  { id: 'super', label: 'সুপার অ্যাডমিন', description: 'সম্পূর্ণ সিস্টেম, ইউজার ও রোল ব্যবস্থাপনা', mfa: true },
  { id: 'sysadmin', label: 'ডিএমপি সিস্টেম অ্যাডমিনিস্ট্রেটর', description: 'কনফিগারেশন, টেমপ্লেট ও ইন্টিগ্রেশন', mfa: true },
  { id: 'operator', label: 'নোটিশ প্রসেসিং অপারেটর', description: 'নোটিশ আপলোড ও OCR তথ্য সংশোধন', mfa: false },
  { id: 'validator', label: 'যাচাইকারী কর্মকর্তা', description: 'তথ্য যাচাই ও সংশোধনে ফেরত', mfa: false },
  { id: 'approver', label: 'অনুমোদনকারী কর্মকর্তা', description: 'অনুমোদন ও নিরাপদ নোটিশ তৈরির অনুমতি', mfa: true },
  { id: 'dispatch', label: 'প্রিন্ট ও প্রেরণ অপারেটর', description: 'PDF তৈরি, প্রিন্ট ও ডাক প্রেরণ', mfa: false },
  { id: 'monitor', label: 'মনিটরিং কর্মকর্তা', description: 'কার্যক্রম, প্রতারণা রিপোর্ট ও পরিসংখ্যান', mfa: false }
];

export const demoUsers: DemoUser[] = [
  { userId: 'dmp.kamrul', name: 'মোঃ কামরুল হাসান', title: 'উপ-পুলিশ কমিশনার', dept: 'ট্রাফিক বিভাগ', role: 'super', bp: 'BP-7501104218' },
  { userId: 'dmp.ariful', name: 'মোঃ আরিফুল ইসলাম', title: 'সিস্টেম অ্যাডমিনিস্ট্রেটর', dept: 'আইসিটি বিভাগ', role: 'sysadmin', bp: 'BP-8812207731' },
  { userId: 'dmp.rakib', name: 'এএসআই মোঃ রাকিবুল হাসান', title: 'সহকারী উপ-পরিদর্শক', dept: 'তেজগাঁও ট্রাফিক বিভাগ', role: 'operator', bp: 'BP-9214155702' },
  { userId: 'dmp.nasrin', name: 'এসআই নাসরিন আক্তার', title: 'উপ-পরিদর্শক', dept: 'তেজগাঁও ট্রাফিক বিভাগ', role: 'validator', bp: 'BP-9011089934' },
  { userId: 'dmp.shahriar', name: 'মোঃ শাহরিয়ার আলম', title: 'সহকারী পুলিশ কমিশনার', dept: 'তেজগাঁও ট্রাফিক বিভাগ', role: 'approver', bp: 'BP-8510122846' },
  { userId: 'dmp.zahid', name: 'মোঃ জাহিদুল করিম', title: 'প্রিন্ট ও প্রেরণ অপারেটর', dept: 'ট্রাফিক সদর দপ্তর', role: 'dispatch', bp: 'BP-9405218863' },
  { userId: 'dmp.farhana', name: 'ফারহানা ইয়াসমিন', title: 'অতিরিক্ত উপ-পুলিশ কমিশনার', dept: 'ট্রাফিক মনিটরিং সেল', role: 'monitor', bp: 'BP-8209163390' }
];

export const DEMO_PASSWORD = 'demo@123';

export function roleLabel(id: RoleId): string {
  return roles.find((r) => r.id === id)?.label ?? id;
}

export const permissionModules = [
  'নোটিশ আপলোড',
  'OCR সংশোধন',
  'তথ্য যাচাই',
  'অনুমোদন',
  'QR নোটিশ তৈরি',
  'প্রিন্ট ও প্রেরণ',
  'প্রতারণা রিপোর্ট',
  'রিপোর্ট',
  'টেমপ্লেট',
  'ইউজার ব্যবস্থাপনা',
  'অডিট লগ'
];

export const permissionMatrix: Record<RoleId, boolean[]> = {
  super: [true, true, true, true, true, true, true, true, true, true, true],
  sysadmin: [true, true, false, false, true, false, false, true, true, false, true],
  operator: [true, true, false, false, false, false, false, false, false, false, false],
  validator: [false, true, true, false, false, false, false, false, false, false, false],
  approver: [false, false, false, true, true, false, false, true, false, false, false],
  dispatch: [false, false, false, false, true, true, false, false, false, false, false],
  monitor: [false, false, false, false, false, false, true, true, false, false, true]
};
